/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminRunAnalyticsReq
 */
export interface AdminRunAnalyticsReq {
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminRunAnalyticsReq
     */
    productIds: Array<string>;
}

export function AdminRunAnalyticsReqFromJSON(json: any): AdminRunAnalyticsReq {
    return AdminRunAnalyticsReqFromJSONTyped(json, false);
}

export function AdminRunAnalyticsReqFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminRunAnalyticsReq {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'productIds': json['productIds'],
    };
}

export function AdminRunAnalyticsReqToJSON(value?: AdminRunAnalyticsReq | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'productIds': value.productIds,
    };
}

